import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';

import { LoginComponent } from './common-components/login/login.component';
import { NotFoundComponent } from './common-components/not-found/not-found.component';
import { ForgotPasswordComponent } from './common-components/forgot-password/forgot-password.component';
import { ForgotPasswordNewComponent } from './common-components/forgot-password-new/forgot-password-new.component';
import { ChangePasswordComponent } from './common-components/change-password/change-password.component';
import { TwoFactorAuthComponent } from './common-components/two-factor-auth/two-factor-auth.component';
import { ResetPasswordComponent } from './common-components/reset-password/reset-password.component';
import { WelcomePageComponent } from './common-components/welcome-page/welcome-page.component';
import { MultipleTabComponent } from './common-components/multiple-tab/multiple-tab.component';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  { path: 'login', component: LoginComponent },
  { path: 'two-factor-auth', component: TwoFactorAuthComponent },
  { path: 'welcome-page', component: WelcomePageComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'forgot-password-new/:securityCode', component: ForgotPasswordNewComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'multiple-tab', component: MultipleTabComponent },

  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
    data: { route: ['change-password'] }
  },

  // ✅ Standalone feature routes
  {
    path: 'agent',
    loadChildren: () =>
      import('./agent_modules/agent.routes')
        .then(m => m.AGENT_ROUTES)
  },
  {
    path: 'supervisor',
    loadChildren: () =>
      import('./supervisor_modules/supervisor.routes')
        .then(m => m.SUPERVISOR_ROUTES)
  },
  {
    path: 'clientsupervisor',
    loadChildren: () =>
      import('./client_supervisor_modules/client-supervisor.routes')
        .then(m => m.CLIENT_SUPERVISOR_ROUTES)
  },
  {
    path: 'clientuser',
    loadChildren: () =>
      import('./client_user_modules/client-user.routes')
        .then(m => m.CLIENT_USER_ROUTES)
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin_modules/admin.routes')
        .then(m => m.ADMIN_ROUTES)
  },
  {
    path: 'administrator',
    loadChildren: () =>
      import('./administrator_modules/administrator.routes')
        .then(m => m.ADMINISTRATOR_ROUTES)
  },
  {
    path: 'director',
    loadChildren: () =>
      import('./director_modules/director.routes')
        .then(m => m.DIRECTOR_ROUTES)
  },
  {
    path: 'manager',
    loadChildren: () =>
      import('./manager_modules/manager.routes')
        .then(m => m.MANAGER_ROUTES)
  },
  {
    path: 'controller',
    loadChildren: () =>
      import('./controller_modules/controller.routes')
        .then(m => m.CONTROLLER_ROUTES)
  },
  {
    path: 'qc',
    loadChildren: () =>
      import('./qc_modules/qc.routes')
        .then(m => m.QC_ROUTES)
  },

  { path: '**', component: NotFoundComponent }
];
